<script>
import { products } from '@site/data/products'
import { useConsult } from '@site/composables/useConsult'
import AppIcon from '@site/components/common/AppIcon.vue'

export default {
  name: 'NovaLaunchSection',
  components: { AppIcon },
  data() {
    const { open } = useConsult()
    const nova = products.find((p) => p.isNew) || products[1]
    return {
      open,
      nova,
      novaHighlights: [
        { icon: 'rocket', title: '更快性能', desc: '引擎级优化，开单查询快到飞起' },
        { icon: 'check', title: '更便捷操作', desc: '智能化流程，省心又省力' },
        { icon: 'sync', title: '更快迭代', desc: '新品功能持续上线，先人一步' },
      ],
    }
  },
}
</script>

<template>
  <section class="section nova-launch" id="nova-launch">
    <div class="nova-launch__mesh">
      <span class="nova-launch__mesh-blob nova-launch__mesh-blob--1"></span>
      <span class="nova-launch__mesh-blob nova-launch__mesh-blob--2"></span>
      <span class="nova-launch__mesh-blob nova-launch__mesh-blob--3"></span>
    </div>
    <div class="container">
      <div class="nova-launch__inner">
        <div class="nova-launch__content">
          <span class="nova-launch__badge">
            <AppIcon name="rocket" :size="15" /> 新品上市
          </span>
          <span class="nova-launch__date">2026.08.01 正式发布</span>
          <h2>航富通 <span class="nova-launch__nova">Nova</span> 全新旗舰版</h2>
          <p class="nova-launch__sub">更快 · 更省心 · 更快迭代，为你的好品味生意而生</p>

          <div class="nova-launch__points">
            <div v-for="(h, i) in novaHighlights" :key="i" class="nova-launch__point">
              <span class="nova-launch__point-icon"><AppIcon :name="h.icon" :size="18" /></span>
              <div>
                <strong>{{ h.title }}</strong>
                <p>{{ h.desc }}</p>
              </div>
            </div>
          </div>

          <div class="nova-launch__cta">
            <router-link :to="nova.link" class="btn btn--primary">了解 Nova</router-link>
            <button class="btn btn--outline" @click="open">立即咨询</button>
          </div>
        </div>

        <div class="nova-launch__visual">
          <div class="nova-launch__card">
            <div class="nova-launch__card-head">
              <span class="nova-launch__card-mark"><AppIcon name="rocket" :size="20" /></span>
              <span class="nova-launch__card-tag">旗舰版</span>
            </div>
            <h3>航富通 Nova</h3>
            <p class="nova-launch__card-tagline">更快性能 · 更便捷 · 更快迭代</p>
            <div class="nova-launch__card-line"></div>
            <div class="nova-launch__card-spec"><span>性能</span><strong>引擎级优化</strong></div>
            <div class="nova-launch__card-spec"><span>体验</span><strong>智能化便捷</strong></div>
            <div class="nova-launch__card-spec"><span>迭代</span><strong>新功能持续上线</strong></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>


<style lang="scss" scoped>
.nova-launch {
  position: relative;
  overflow: hidden;
  background: $gradient-nova;
  color: $color-white;

  // 与上方深色 Hero 平滑衔接：顶部从 Hero 底部色过渡到 Nova 渐变
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 260px;
    background: linear-gradient(180deg, #3B1D5A 0%, rgba(59, 29, 90, 0) 100%);
    pointer-events: none;
    z-index: 0;
  }

  &__mesh { position: absolute; inset: 0; pointer-events: none; }
  &__mesh-blob {
    position: absolute;
    border-radius: 50%;
    filter: blur(60px);
    &--1 { width: 480px; height: 480px; top: -100px; right: -60px; background: rgba(255, 255, 255, 0.16); }
    &--2 { width: 380px; height: 380px; bottom: -80px; left: -60px; background: rgba(168, 85, 247, 0.4); }
    &--3 { width: 260px; height: 260px; top: 30%; left: 40%; background: rgba(245, 158, 11, 0.22); }
  }

  &__inner {
    position: relative;
    display: grid;
    grid-template-columns: 1.1fr 0.9fr;
    gap: 56px;
    align-items: center;
    z-index: 1;
  }

  &__content { display: flex; flex-direction: column; align-items: flex-start; }

  &__badge {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    background: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.4);
    border-radius: $radius-full;
    padding: 6px 18px;
    font-size: 13px;
    font-weight: $weight-semibold;
    margin-bottom: 18px;
    backdrop-filter: blur(6px);
  }

  &__date {
    display: inline-block;
    font-size: 13px;
    letter-spacing: 0.1em;
    color: rgba(255, 255, 255, 0.82);
    font-weight: $weight-medium;
    margin-bottom: 14px;
  }

  h2 {
    color: $color-white;
    font-size: $font-section;
    font-weight: $weight-black;
    letter-spacing: -0.02em;
    margin-bottom: 12px;
  }

  &__sub { font-size: 19px; color: rgba(255, 255, 255, 0.9); margin-bottom: 32px; }

  &__nova {
    background: linear-gradient(120deg, #FFFFFF 0%, #FFD9EC 55%, #FFFFFF 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    filter: drop-shadow(0 2px 10px rgba(0, 0, 0, 0.22));
  }

  &__points {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-bottom: 36px;
    width: 100%;
  }

  &__point {
    display: flex;
    gap: 12px;
    align-items: flex-start;
  }

  &__point-icon {
    width: 40px; height: 40px; border-radius: 12px;
    background: rgba(255, 255, 255, 0.2);
    display: flex; align-items: center; justify-content: center;
    flex-shrink: 0;
    color: $color-white;
  }

  &__point strong { display: block; color: $color-white; font-size: 15px; margin-bottom: 3px; }
  &__point p { color: rgba(255, 255, 255, 0.82); font-size: 13px; line-height: 1.5; }

  &__cta { display: flex; gap: 14px; }

  &__visual { display: flex; justify-content: center; }

  &__card {
    width: 100%;
    max-width: 360px;
    background: rgba(255, 255, 255, 0.12);
    border: 1px solid rgba(255, 255, 255, 0.28);
    border-radius: $radius-xl;
    padding: 36px 32px;
    backdrop-filter: blur(12px) saturate(150%);
    box-shadow: 0 30px 70px rgba(0, 0, 0, 0.22);

    &-head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 22px; }
    &-mark { width: 46px; height: 46px; border-radius: 14px; background: rgba(255,255,255,0.24); display: flex; align-items: center; justify-content: center; }
    &-tag { font-size: 12px; font-weight: $weight-semibold; letter-spacing: 0.08em; color: rgba(255,255,255,0.9); border: 1px solid rgba(255,255,255,0.36); border-radius: $radius-full; padding: 5px 14px; }

    h3 { color: $color-white; font-size: 32px; font-weight: $weight-black; margin-bottom: 8px; }
    &-tagline { color: rgba(255,255,255,0.86); font-size: 15px; margin-bottom: 22px; }

    &-line { height: 1px; background: rgba(255,255,255,0.26); margin-bottom: 22px; }

    &-spec {
      display: flex; align-items: center; justify-content: space-between;
      padding: 12px 0; border-bottom: 1px solid rgba(255,255,255,0.16);
      span { color: rgba(255,255,255,0.7); font-size: 14px; }
      strong { color: $color-white; font-size: 14px; font-weight: $weight-semibold; }
    }
  }

  @media (max-width: $bp-md) {
    &__inner { grid-template-columns: 1fr; gap: 36px; }
    &__points { grid-template-columns: repeat(3, 1fr); }
  }

  @media (max-width: $bp-sm) {
    &__inner { grid-template-columns: 1fr; }
    &__points { grid-template-columns: 1fr; gap: 14px; }
    h2 { font-size: 32px; }
    &__cta { flex-direction: column; width: 100%; }
    &__card { max-width: 100%; }
  }
}
</style>



// WEBPACK FOOTER //
// src/site/components/home/NovaLaunchSection.vue